import TopNewsItem, { trendingItemObject } from "ui/files/others/TopNewsItem";
export const trendingDemo: trendingItemObject[] = [
    {
        hashtag: "top_news",
        nPosts: 230,
        trending: false
    },
    {
        hashtag: "stop_war",
        nPosts: 200,
        trending: false
    },
    {
        hashtag: "soccer",
        nPosts: 184,
        trending: false
    },
    {
        hashtag: "fires",
        nPosts: 103,
        trending: false
    },
    {
        hashtag: "tennis",
        nPosts: 39,
        trending: false
    }
];
const TopNewsCard = () => {
    return (
        <div className="card">
            <div className="card-heading is-bordered">
                <h4>What's New</h4>
                <div className="dropdown is-spaced is-neutral is-right">
                    <a href="#" className="momeento-p grey-text">
                        view more
                    </a>
                </div>
            </div>
            <div className="card-body no-padding">
                {trendingDemo.map((i) => (
                    <TopNewsItem item={i} key={i.hashtag} />
                ))}
            </div>
        </div>
    );
};

export default TopNewsCard;
